import { ref } from 'vue'

export const pollingAllowed = ref(true)
window.addEventListener('focus', () => {
  pollingAllowed.value = true
})
window.addEventListener('blur', () => {
  pollingAllowed.value = false
})
export const allowPolling = () => {
  pollingAllowed.value = true
}

const polling = (callback: Function): Function => {
  let stopped = false
  let timer: number
  const stop = () => {
    stopped = true
    window.clearTimeout(timer)
  }
  const next = (duration: number) => {
    if (stopped) return
    timer = window.setTimeout(() => {
      if (pollingAllowed.value) {
        callback(next, stop)
      } else { // skip
        next(duration)
      }
    }, duration)
  }
  callback(next, stop)
  return stop
}
export default polling
